import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'placeholder' })
export class PlaceholderPipe implements PipeTransform {
  transform(value: undefined | string, placeholder: string): undefined | string {

    if (!value)
      return;

    // TODO: can we make this independent of the currency format?
    const val = value.replace(',', '').replace('$', '');

    if (parseFloat(val) === 0 || val === '(0)')
      return placeholder;

    return value;
    }
}
